import { z } from 'zod'

export type Map = naver.maps.Map
export type Bounds = naver.maps.Bounds

export const ZCoordinates = z.object({
  lat: z.number(),
  lng: z.number(),
})

export type TCoordinates = z.infer<typeof ZCoordinates>

class MapManager {
  private static instance: MapManager
  private map: Map | null = null
  private isInitialized = false
  isDragging = false
  private pinchingCount = 0

  private constructor() {}

  static getInstance(): MapManager {
    if (!MapManager.instance) {
      MapManager.instance = new MapManager()
    }

    return MapManager.instance
  }

  initialize(options: naver.maps.MapOptions & { id: string }): Map {
    if (this.isInitialized && this.map) {
      return this.map
    }

    this.map = new naver.maps.Map(options.id, options)
    this.isInitialized = true

    return this.map
  }

  getMap() {
    return this.map
  }

  reset() {
    this.withMap(map => {
      map.destroy()
    })

    this.map = null
    this.isInitialized = false
  }

  // 안전한 맵 접근 헬퍼
  withMap<T>(callback: (map: Map) => T): T | null {
    const map = this.getMap()

    if (!map) {
      return null
    }

    return callback(map)
  }

  setZoomControl() {
    this.withMap(map => {
      map.setOptions({
        zoomControl: true,
        zoomControlOptions: {
          position: naver.maps.Position.RIGHT_TOP,
          style: naver.maps.ZoomControlStyle.SMALL,
        },
      })
    })
  }

  setIsDragging(isDragging: boolean) {
    this.isDragging = isDragging
  }

  getIsDragging() {
    return this.isDragging
  }

  startPinching() {
    this.pinchingCount++
  }

  endPinching() {
    this.pinchingCount = Math.max(0, this.pinchingCount - 1)
  }

  getIsPinching() {
    return this.pinchingCount > 0
  }

  changeMapCenter({
    lat,
    lng,
    zoomLevel,
  }: {
    lat: number
    lng: number
    zoomLevel: number | null
  }) {
    this.withMap(map => {
      map.setCenter(new naver.maps.LatLng(lat, lng))
      if (zoomLevel) map.setZoom(zoomLevel)
    })
  }
}

export const mapManager = MapManager.getInstance()
